var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgPlayFilled16 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.73 4.19a1.05 1.05 0 0 0-1.58.906v5.608c0 .81.88 1.315 1.58.907l4.806-2.804a1.05 1.05 0 0 0 0-1.814L6.729 4.19Z",
    clipRule: "evenodd"
  })));
});
SvgPlayFilled16.displayName = "SvgPlayFilled16";
export default SvgPlayFilled16;